<template>
    <div class="wallet">
        <div class="row align-items-center funds-transfer__tit-page tit_page">
            <div class="col-12 col-lg-8">
                <h1>Comprovante de Pagamento</h1>
            </div>
            <div class="col-12 col-lg-4">
                <div class="back back-hide float-md-right">
                    <router-link to="/investimentos/carteira-investimento" title="Voltar"><i>&nbsp;</i> voltar</router-link>
                </div>
            </div>
        </div>
        <hr class="divider">
        <div class="row justify-content-center">
            <div class="col-12 col-md-12 col-lg-7">

                <!-- COMPROVANTE DE REPAGAMENTO -->
                <div class="row align-items-center">
                    <div class="col-12 col-md-6 d-flex justify-content-sm-center justify-content-md-end">

                        <!-- INÍCIO COMPROVANTE -->
                        <div class="coupon" id="cupom">
                            <div class="coupon__head"></div>
                            <div class="coupon__body">
                                <img src="/static/assets/images/logotipo-iouu.png" width="70" alt="Logotipo IOUU">
                                <p class="id">COMPROVANTE {{idComprovante}}</p>
                                <div class="date">
                                    RECEBIDO EM: <br/><span>{{dataOperacao}}</span>
                                </div>
                                <ul>
                                    <li>De: <span>{{nomeEmpresa}}</span></li>
                                    <li>Parcela: <span>{{recebimentoParcela}}</span></li>
                                    <li>Principal: <span>{{valorPrincipal}}</span></li>
                                    <li>Juros: <span>{{juros}}</span></li>

                                    <li>Multa por atraso: <span>{{multa}}</span></li>

                                    <li>Valor bruto pago: <span>{{valorBruto}}</span></li>
                                    <li>IR: <span>{{ir}}</span></li>
                                    <li>Valor Liquido: <span>{{valorLiquido}}</span></li>
                                    <li>CNPJ: <span>{{documento}}</span></li>
                                </ul>
                                <!-- <ul>
                                    <li>Para: <span>teste</span></li>
                                    <li v-if="true">Valor Liquido Recebido: <span>R$ teste</span></li>
                                    <li v-else>Valor Recebido: <span>R$ teste</span></li>
                                    <li>CPF/CNPJ: <span>teste</span></li>
                                </ul> -->
                            </div>
                            <div class="coupon__foot"></div>
                        </div>
                        <!-- FINAL COMPROVANTE -->
                    </div>
                    <div class="col-12 col-md-6">
                        <div class="wallet__description">
                            <h2>Recebimento realizado</h2>
                            <div>
                              <p>
                                <strong>Valor bruto pago</strong>
                                <span class="text-primary">{{valorBruto}}</span>
                              </p>
                              <p>
                                <strong>IR</strong>
                                <span class="text-danger">{{ir}}</span>
                              </p>
                              <p>
                                <strong>Valor líquido pago</strong>
                                <span class="text-success">{{valorLiquido}}</span>
                              </p>
                            </div>
                            <button class="btn btn-outline-secondary btn-lg" title="Imprimir comprovante" @click="printPdf()"><i class="fas fa-print"></i>Imprimir comprovante</button>
                            <button class="btn btn-outline-secondary btn-lg" title="Salvar comprovante" @click="savePdf()"><i class="fas fa-download"></i>Salvar comprovante</button>
                        </div>
                    </div>
                </div>
                <!-- :::::::::::::::::::: -->
                
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import WalletService from '../services/api/wallet';
import ApiClient from '../utils/api-client'
import * as mutationTypes from '@/store/mutation-types.js'
import Masker from '../utils/masker'
import pdf from '../utils/pdf-helper'

    export default {

        data() {
            return {
                investor: null,
                tranferencia: null,
                detalhesOperacao: null,
                type: "teste",
                loading: false,
                loadingTransaction: false,
                loadingBank: false,
                ted: "0,00",
                currentPage: 0,
                pageCount: 0,
            }
        },

        methods: {
            FV(rate, periods, payment, value, type) {
              // Credits: algorithm inspired by Apache OpenOffice

              // Initialize type
              type = (typeof type === 'undefined') ? 0 : type;

              // Evaluate rate (TODO: replace with secure expression evaluator)
              rate = eval(rate);

              // Return future value
              var result;
              if (rate === 0) {
                result = value + payment * periods;
              } else {
                var term = Math.pow(1 + rate, periods);
                if (type === 1) {
                  result = value * term + payment * (1 + rate) * (term - 1.0) / rate;
                } else {
                  result = value * term + payment * (term - 1) / rate;
                }
              }

              // result = Math.round(result * 100) / 100;

              return -result;
            },
            IPMT(rate, period, periods, present, future, type) {
              // Credits: algorithm inspired by Apache OpenOffice

              // Initialize type
              type = (typeof type === 'undefined') ? 0 : type;

              // Initialize future
              future = (typeof future === 'undefined') ? 0 : future;

              // Evaluate rate and periods (TODO: replace with secure expression evaluator)
              rate = eval(rate);
              periods = eval(periods);

              // Compute payment
              var payment = this.PMT(rate, periods, present, future, type);

              // Compute interest
              var interest;
              if (period === 1) {
                if (type === 1) {
                  interest = 0;
                } else {
                  interest = -present;
                }
              } else {
                if (type === 1) {
                  interest = this.FV(rate, period - 2, payment, present, 1) - payment;
                } else {
                  interest = this.FV(rate, period - 1, payment, present, 0);
                }
              }

              var result = interest * rate;
              // result = Math.round(result * 100) / 100;

              // Return interest
              return interest * rate;
            },
            
            PMT(rate, periods, present, future, type) {
              // Credits: algorithm inspired by Apache OpenOffice

              // Initialize type
              type = (typeof type === 'undefined') ? 0 : type;

              // Initialize future
              future = 0;

              // Evaluate rate (TODO: replace with secure expression evaluator)
              rate = eval(rate);

              // Return payment
              var result;
              if (rate === 0) {
                result = (present + future) / periods;
              } else {
                var term = Math.pow(1 + rate, periods);
              if (type === 1) {
                result = (future * rate / (term - 1) + present * rate / (1 - 1 / term)) / (1 + rate);
              } else {
                result = future * rate / (term - 1) + present * rate / (1 - 1 / term);
                }
              }

              // result = Math.round(result * 100) / 100;

              return -result;
            },

            formatCurrency(value) {
                if(value != null)
                    return "R$ " + value.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2});

                return 0;
            },

            formatReal(num) {
                let real;
                real = parseFloat(num.replace(/[^\d]+/g, '')) / 100;
                return real;
            },

            formatDate(date) {

              let spliter = date.split("T")
              let newDate = spliter[0].split('-')
              let time = spliter[1].split(':')

              return `${newDate[2]}/${newDate[1]}/${newDate[0]}`
            },
            savePdf() {
              pdf.Save('cupom', this.idComprovante);
            },
            printPdf() {
              pdf.Print('cupom', this.idComprovante);
            },
            getIndiceFatura(indice) {
              return indice != null ? indice + 1 : ""
            }
        },
        computed: {

          idComprovante: function() {
            return this.$route.params.id;
          },
          dataOperacao: function() {
            if(this.detalhesOperacao && this.detalhesOperacao.Data)
              return this.formatDate(this.detalhesOperacao.Data);
            return "";
          },
          nomeEmpresa: function() {
            if(this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento && this.detalhesOperacao.Detalhes.Pagamento.NomeEmpresa)
              return this.detalhesOperacao.Detalhes.Pagamento.NomeEmpresa;
            return "";
          },
          recebimentoParcela: function() {
            if(this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento)
              return `${this.detalhesOperacao.Detalhes.Pagamento.IndiceParcela} / ${this.detalhesOperacao.Detalhes.Pagamento.Prazo}`
          },
          valorPrincipal: function() {
            if (this.detalhesOperacao.Detalhes.Pagamento.Ipmt && this.detalhesOperacao.Detalhes.Pagamento.Multa) {
                return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.ValorBruto - this.detalhesOperacao.Detalhes.Pagamento.Ipmt - this.detalhesOperacao.Detalhes.Pagamento.Multa)
            } else if (!this.detalhesOperacao.Detalhes.Pagamento.Multa && !this.detalhesOperacao.Detalhes.Pagamento.Ipmt) {
                return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.ValorBruto)
            } else if (!this.detalhesOperacao.Detalhes.Pagamento.Ipmt) {
                return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.ValorBruto - this.detalhesOperacao.Detalhes.Pagamento.Multa)
            }
            return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.ValorBruto - this.detalhesOperacao.Detalhes.Pagamento.Ipmt)
          },
          juros() {
            if(this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento && this.detalhesOperacao.Detalhes.Pagamento.Ipmt)
              return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.Ipmt);
            else 
              return this.formatCurrency(0);
          },
          multa() {
            if(this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento && this.detalhesOperacao.Detalhes.Pagamento.Multa)
              return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.Multa);
            else 
              return this.formatCurrency(0);
          },
          valorBruto() {
            if(this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento)
              return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.ValorBruto);
          },
          ir() {
            if(this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento && this.detalhesOperacao.Detalhes.Pagamento.Ir)
              return this.formatCurrency(this.detalhesOperacao.Detalhes.Pagamento.Ir);
            else 
              return this.formatCurrency(0);
          },
          documento() {
            if(this.detalhesOperacao && this.detalhesOperacao.Detalhes && this.detalhesOperacao.Detalhes.Pagamento)
              return Masker.maskCnpj(this.detalhesOperacao.Detalhes.Pagamento.DocumentoEmpresa);
          },
          valorLiquido() {
            return this.formatCurrency(this.detalhesOperacao.Valor);
          },


          CalcLiquid: function() {
            let ipmt,
                RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
                IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
                Prazo = this.transferencia.SolicitacaoID.Prazo,
                Valor = this.transferencia.ReservaInvestimentoID.Valor,
                aliqIR,
                Ir;

                ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
                ipmt = Math.round(ipmt * 100) / 100;

                if(IndiceFatura >= 1 && IndiceFatura < 6) aliqIR = 0.225;
                else if(IndiceFatura >= 6 && IndiceFatura < 12) aliqIR = 0.2;
                else if(IndiceFatura >= 12 && IndiceFatura < 24) aliqIR = 0.175;
                else aliqIR = 0.15;

                Ir = ipmt * aliqIR;

            return this.formatCurrency(this.transferencia.Valor - Ir)
          },
          CalcIR: function() {
            let ipmt,
                RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
                IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
                Prazo = this.transferencia.SolicitacaoID.Prazo,
                Valor = this.transferencia.ReservaInvestimentoID.Valor,
                aliqIR;

                ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
                ipmt = Math.round(ipmt * 100) / 100;

                if(IndiceFatura >= 1 && IndiceFatura < 6) aliqIR = 0.225;
                else if(IndiceFatura >= 6 && IndiceFatura < 12) aliqIR = 0.2;
                else if(IndiceFatura >= 12 && IndiceFatura < 24) aliqIR = 0.175;
                else aliqIR = 0.15;


            return this.formatCurrency(ipmt * aliqIR);
          },
          CalcJuros: function() {
              let ipmt,
                  RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
                  IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
                  Prazo = this.transferencia.SolicitacaoID.Prazo,
                  Valor = this.transferencia.ReservaInvestimentoID.Valor;


              ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
              ipmt = Math.round(ipmt * 100) / 100;

              console.log(this.transferencia)

              return this.formatCurrency(ipmt);
          },

          CalcMulta: function() {
            if(this.transferencia.Juros != undefined && this.transferencia.Juros  > 0)
              return this.transferencia.Juros

              return 0;
          },
          CalcCapital: function() {
            let ipmt,
                RetornoBrutoMensal = this.transferencia.SolicitacaoID.RetornoBrutoMensal / 100,
                IndiceFatura = this.getIndiceFatura(this.transferencia.FaturaID),
                Prazo = this.transferencia.SolicitacaoID.Prazo,
                Valor = this.transferencia.ReservaInvestimentoID.Valor;

              ipmt = -this.IPMT(RetornoBrutoMensal, IndiceFatura, Prazo, Valor);
              ipmt = Math.round(ipmt * 100) / 100;

              if(this.transferencia.Ipmt > 0) ipmt = this.transferencia.Ipmt;

              if(this.transferencia.Juros == undefined || this.transferencia.Juros == null)
                this.transferencia.Juros = 0;

            return this.formatCurrency((this.transferencia.Valor - this.transferencia.Juros) - ipmt);
          },
          DocumentoEmpresa: function() {
            return Masker.maskCpf(this.transferencia.SolicitacaoID.Documento);
          },
          valor: function() {
              return this.formatCurrency(this.transferencia.Valor)
          },
          impostoRenda: function() {
              return this.formatCurrency(this.transferencia.IR)
          },
          valorComTed: function() {
              return this.formatCurrency(this.transferencia.Valor - this.formatReal(this.ted))
          },
          nome: function() {
              return this.investor.NomeCompleto;
          },
          nomeBanco: function() {
              if(this.investor != null && this.investor.DadosBancarios != null && this.bank != null)
                  return this.bank.length > 0 ? this.bank[0].nome : `Outro - Codigo do banco: ${this.investor.DadosBancarios.CodigoBanco}`

              return ""
          },
          tipoConta: function() {
              if(this.transferencia != null && this.transferencia.DadosBancarios != null)
                  return this.transferencia.DadosBancarios.TipoConta  === 1 ? "Conta Corrente" : "Conta Poupança"
              return "";
          },
          NumeroConta: function() {
              if(this.transferencia != null && this.transferencia.DadosBancarios != null)
                  return this.transferencia.DadosBancarios.Conta
              return ""
          },
          agencia: function() {

              if(this.transferencia != null && this.transferencia.DadosBancarios != null)
                  return this.transferencia.DadosBancarios.Agencia
              return ""
          },
          //tagueamento GA
          taggingGA() {
            this.$ga.page({
              page: '/carteira-investimento/comprovante/pagamento/:id',
              title: 'ComprovantePagamento',
            })
          },
        },
        async created() {

          this.$store.commit(mutationTypes.START_LOADING);

          const { data } = await WalletService.GetDetalhesOperacao(this.$route.params.id);

          if(data) {

            this.detalhesOperacao = data;

            console.log("Detalhes");
            console.log(this.detalhesOperacao);
            

          } else {
            console.warn("error request")
          }

             this.$store.commit(mutationTypes.STOP_LOADING);
             //tagueamento GA
            await this.taggingGA();
        }
    }
</script>

<style lang="scss" scoped>
@import "../assets/styles/iouu/mixins";
  .btn-lg {
    @include brkp-01(1515px) {
      width: 60%;
      display: inline-block;
      font-size: 0.7rem;
    }

    &:last-of-type {
      @include brkp-01(1515px) {
        margin-top: 0.6rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/WalletPagamento.vue